import { CatalogItemListFilter } from '@common/model/catalog/item/list.filter';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { format } from 'date-fns';
import { CITY_SEARCH_FORM_FIELD_NAME_DEFAULT } from '@cp/entities/location';
import { dateOnlyISOStringToDateObj } from '@cp/shared/lib';
import { FormAvailableOnlyFieldName } from '../../../ui/availableOnly/model';
import { CatalogSortingTypes } from '../../../model/types';
import { FormFieldName, FormModel } from '../form';
import { DATE_VALUE_FORMAT } from '../const';

export const getDefaultValues = (
  defaultCity: CityViewModel | undefined,
  defaultFilter: CatalogItemListFilter,
  defaultSorting?: CatalogSortingTypes,
): FormModel => {
  const formValues: FormModel = {
    [CITY_SEARCH_FORM_FIELD_NAME_DEFAULT]: defaultCity,
    [FormAvailableOnlyFieldName.AvailableOnly]: Boolean(defaultFilter.date),
    [FormAvailableOnlyFieldName.Date]: defaultFilter.date
      ? format(dateOnlyISOStringToDateObj(new Date(defaultFilter.date).toISOString()), DATE_VALUE_FORMAT)
      : null,
    [FormAvailableOnlyFieldName.Start]: defaultFilter.start ?? null,
    [FormAvailableOnlyFieldName.End]: defaultFilter.end ?? null,
    [FormFieldName.Sorters]: defaultSorting || CatalogSortingTypes.Normal,
  };

  return formValues;
};
